import styled from 'styled-components'
import arrowDown from '../../../../assets/certificates/AddCertificate/arrow-down.svg'

export const Container = styled.div`
    background-color: #fff;
    width: 17rem;
    border-radius: 5px;
    border: 1px solid #0090d3;
    height: fit-content;
    padding-bottom: 1.2rem;
    margin-top: 0.3rem;
    margin-left: 1.3rem;
    border-radius: 0.7rem;
    align-items: center;
`

export const OptionsContainer = styled.div`
    display: flex;    
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
`
export const OptionDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 2.7rem;
    cursor: pointer;
    border-radius: 0.7rem;`

export const OptionText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: clamp(0.9rem, calc(0.9rem + 0.1vw) , 1.4rem);
    font-weight: 400;
    margin-left: 0.5rem;
    margin-right: 0.5rem;`

